<template>
  <div v-if="document && collection">
    <div class="header-container background-container">
      <div class="mt-3 mb-3 header-section background-container">
        <!-- <button variant="light" class="align back-button mr-2" @click="goBack">
          <i class="ri-arrow-left-line mr-1"></i>
        </button> -->
        <div class="align">
          <i class="ri-file-fill mr-2 medium-icon"></i>
          <span class="document-title muted-text">{{ document.id }}</span>
        </div>
      </div>
      <div class="header-section document-actions background-container">
        <!-- Add field popover -->
        <el-popover
          placement="bottom-end"
          trigger="click"
          :width="fit-content"
          :transition="null"
          :visible="addFieldPopoverVisible"
        >
          <template #reference>
            <button
              @click="addFieldPopoverVisible = true"
              class="btn action-btn apply-btn mr-2"
            >
              Add field
            </button>
            <i class="ri-pencil-fill medium-icon"></i>
          </template>
          <div class="filter-content">
            <div class="filter-row mb-2">
              <div class="filter-label-input mr-2">
                <label>Field</label>
                <el-select
                  @change="onNewFiledOjectNameSelected"
                  :model-value="newFieldObject.name"
                  @update:model-value="value => newFieldObject.name = value"
                  placeholder="Select"
                >
                  <el-option
                    v-for="fieldName in allowAddFieldsNames"
                    :key="fieldName"
                    :label="fieldName"
                    :value="fieldName"
                  />
                </el-select>
              </div>
              <div class="filter-label-input mr-2">
                <label>Type</label>
                <el-select
                  :model-value="newFieldObject.editType"
                  @update:model-value="value => newFieldObject.editType = value"
                  disabled
                  placeholder="Select"
                >
                </el-select>
              </div>
              <div
                v-if="newFieldObject.editType === 'number' || newFieldObject.editType === 'string'"
                class="filter-label-input"
              >
                <label>Value</label>
                <el-input
                  class="filter"
                  :class="{ 'is-invalid': newFieldObject.invalidValueInput }"
                  :model-value="newFieldObject.editValue"
                  @update:model-value="value => newFieldObject.editValue = value"
                />
                <span
                  v-if="newFieldObject.invalidValueInput"
                  class="invalid-input-message"
                  >*Invalid input</span
                >
              </div>
              <div
                v-else-if="newFieldObject.editType === 'boolean'"
                class="filter-label-input"
              >
                <label>Value</label>
                <el-select
                  :model-value="newFieldObject.editValue"
                  @update:model-value="value => newFieldObject.editValue = value"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in booleanOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div>
            <div
              v-if="newFieldObject.editType === 'object'"
              class="object-field-container"
            >
              <div class="vertical-dots"><p></p></div>
              <div class="keyValueEditors">
                <div
                  v-for="index in newFieldObject.numItemsInArray"
                  :key="index"
                  class="filter-row mb-2"
                >
                  <div class="horizontal-dots"></div>

                  <div class="filter-label-input mr-2">
                    <label>Field</label>
                    <el-input
                      class="filter"
                      @update:model-value="value => newFieldObject.editValue[index - 1].editField = value"
                      :class="{ 'is-invalid': newFieldObject.editValue[index - 1].invalidFieldInput }"
                      :model-value="newFieldObject.editValue[index - 1].editField"
                    />
                    <span
                      v-if="newFieldObject.editValue[index - 1].invalidFieldInput"
                      class="invalid-input-message"
                      >*Invalid input</span
                    >
                  </div>
                  <div class="filter-label-input mr-2">
                    <label>Type</label>
                    <el-select
                      :model-value="newFieldObject.editValue[index - 1].actualType"
                      disabled
                      placeholder="Select"
                    >
                    </el-select>
                  </div>
                  <div
                    class="filter-label-input mr-2"
                    v-if="newFieldObject.editValue[index - 1].editType === 'selections'"
                  >
                    <label>Value</label>
                    <el-select
                      :model-value="newFieldObject.editValue[index - 1].editValue"
                      @update:model-value="value => newFieldObject.editValue[index - 1].editValue = value"
                      :class="{ 'is-invalid': newFieldObject.editValue[index - 1].invalidValueInput }"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in newFieldObject.editValue[index - 1].selections"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                    <span
                      v-if="newFieldObject.editValue[index - 1].invalidValueInput"
                      class="invalid-input-message"
                      >*Invalid input</span
                    >
                  </div>
                  <div
                  v-if="newFieldObject.name === 'devices'"
                        class="filter-label-input mr-2"
                      >
                        <label>Device Type</label>
                        <el-select
                          placeholder="Select"
                          :model-value="newFieldObject.editValue[index - 1].deviceType"
                           @update:model-value="value => newFieldObject.editValue[index - 1].deviceType = value"
                           :class="{ 'is-invalid': newFieldObject.editValue[index - 1].invalidDeviceType }"

                        >
                          <el-option
                            v-for="item in allDeviceTypes"
                            :key="item"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                        <span
                      v-if="newFieldObject.editValue[index - 1].invalidDeviceType"
                      class="invalid-input-message"
                      >*Invalid input</span
                    >
                  </div>
                  <i v-if="index > 1"
                    class="ri-indeterminate-circle-line remove-item"
                    @click="removeItemFromNewValue(index - 1)"
                  ></i>
                </div>
              </div>
              <div class="add-field-plus">
                <div class="plus-dots"><p></p></div>
                <i
                  class="ri-add-circle-line add-item"
                  @click="addItemToNewValue"
                ></i>
              </div>
            </div>
          </div>
          <div class="filter-actions">
            <div class="action-buttons">
              <button
                @click="onCancelNewFieldPopover"
                class="btn action-btn mr-2"
              >
                Cancel
              </button>
              <button @click="handleAddField" class="btn action-btn apply-btn">
                Add
              </button>
            </div>
          </div>
        </el-popover>
        <button @click="handleDeleteDocument" class="btn action-btn">
          Delete document
        </button>
      </div>
    </div>
    <div>
      <div>
        <el-table
          :data="formattedDocumentData"
          style="width: 100%"
          row-key="index"
          @row-click="handleRowClick"
          :row-class-name="tableRowClassName"
        >
          <!-- Expand Column -->
          <el-table-column type="expand">
            <template #default="props">
              <div v-if="props.row.name === 'screenshots'">
                <div class="image-wall ml-5">
            <el-image
              v-for="(image, index) in props.row.actualValue"
              :key="index"
              class="image-item"
              :src="image"
              :initial-index="currentImagePreviewIndex"
              :preview-src-list="props.row.actualValue"
              @click.native="currentImagePreviewIndex = index"
              :fit="'contain'"
              :hide-on-click-modal="true"
              :preview-teleported=true
            ></el-image>
          </div>
              </div>
              <div v-else-if="props.row.type === 'object'">
                <expand-object-field
                  :pairs="objectKeyValuePairs[props.row.name]"
                  :documentId="docId"
                  :collection="collection"
                  :name="props.row.name"
                ></expand-object-field>
              </div>
              <div v-else-if="props.row.type === 'array'">
                <expand-array-field
                  :documentId="docId"
                  :collection="collection"
                  :name="props.row.name"
                  :array="props.row.actualValue"
                >
                </expand-array-field>
              </div>
            </template>
          </el-table-column>

          <!-- Name Column -->
          <el-table-column prop="name" label="Name" width="250">
            <template #default="scope">
              <div>
                <p class="field-name">{{ scope.row.name }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- Type Column -->
          <el-table-column prop="type" label="Type" width="200">
            <template #default="scope">
              <div>
                {{ scope.row.type }}
              </div>
            </template>
          </el-table-column>
          <!-- Value Column -->
          <el-table-column prop="value" label="Value">
            <template #default="scope">
              <div v-if="scope.row.name === 'screenshots'">
                <div>{{ scope.row.actualValue.length }} screenshots attached</div>
              </div>
              <div v-else>
                <div>{{ trucateString(scope.row.value) }}</div>
              </div>
            </template>
          </el-table-column>
          <!-- Actions Column -->
          <el-table-column width="200">
            <template #default="scope">
              <div
                v-if="(scope.row.name !== 'id' && (!collection.nonEditableFields ||!collection.nonEditableFields.includes(scope.row.name)) && !collection.allFieldsNonEditable)"
              >
                <span v-if="!isRowArrayOrObject(scope.row)">
                  <!-- Primitive data types Popover -->
                  <el-popover
                    placement="bottom-end"
                    trigger="click"
                    :width="fit-content"
                    :visible="editPopoverVisible[scope.row.index]"
                  >
                    <template #reference>
                      <button
                        @click="toggleEditFieldPopover(scope.row.index)"
                        class="btn add-filter-btn"
                      >
                        <i class="ri-pencil-fill medium-icon"></i>
                      </button>
                    </template>
                    <div class="filter-content">
                      <div class="filter-row mb-2">
                        <div class="filter-label-input mr-2">
                          <label>Field</label>
                          <el-input
                            class="filter"
                            :model-value="scope.row.name"
                            disabled
                            @update:model-value="value => scope.row.name = value"
                          />
                        </div>
                        <div class="filter-label-input mr-2">
                          <label>Type</label>
                          <el-select
                            :model-value="scope.row.type"
                            disabled
                            placeholder="Select"
                          >
                          </el-select>
                        </div>
                        <div
                          v-if="scope.row.editType === 'number' || scope.row.editType === 'string'"
                          class="filter-label-input"
                        >
                          <label>Value</label>
                          <el-input
                            class="filter"
                            :class="{ 'is-invalid': scope.row.invalidValueInput }"
                            :model-value="scope.row.editValue"
                            @update:model-value="value => scope.row.editValue = value"
                          />
                          <span
                            v-if="scope.row.invalidValueInput"
                            class="invalid-input-message"
                            >*Invalid input</span
                          >
                        </div>
                        <div
                          v-else-if="scope.row.editType === 'boolean'"
                          class="filter-label-input"
                        >
                          <label>Value</label>
                          
                          <el-select
                            :model-value="scope.row.editValue"
                            @update:model-value="value => scope.row.editValue = value"
                            placeholder="Select"
                          >
                            <el-option
                              v-for="item in booleanOptions"
                              :key="item"
                              :label="item"
                              :value="item"
                            />
                          </el-select>
                        </div>
                        <div
                          v-else-if="scope.row.editType === 'selections'"
                          class="filter-label-input"
                        >
                          <label>Value</label>
                          <el-select
                            :model-value="scope.row.editValue"
                            @update:model-value="value => scope.row.editValue = value"
                            placeholder="Select"
                          >
                            <el-option
                              v-for="item in collection.selections[scope.row.name]"
                              :key="item"
                              :label="item"
                              :value="item"
                            />
                          </el-select>
                        </div>
                        <div
                          v-else-if="scope.row.editType === 'timestamp'"
                          class="filter-label-input"
                        >
                          <label>Value</label>
                          <VueDatePicker
                            :class="{ 'is-invalid': newItems[index - 1].invalidValueInput }"
                            v-model="cope.row.editValue"
                          ></VueDatePicker>
                        </div>
                      </div>
                    </div>
                    <div class="filter-actions">
                      <div class="action-buttons">
                        <button
                          @click="onCancelPopover(scope.row)"
                          class="btn action-btn mr-2"
                        >
                          Cancel
                        </button>
                        <button
                          @click="handleUpdateField(scope.row)"
                          class="btn action-btn apply-btn"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </el-popover>
                </span>
                <span v-else>
                  <AddToField
                    v-if="collection.schema && collection.schema[scope.row.name]"
                    :documentId="docId"
                    :collection="collection"
                    :schema="collection.schema[scope.row.name]"
                    :name="scope.row.name"
                  ></AddToField>
                </span>
                <button
                  v-if="collection.removeableFields && collection.removeableFields.includes(scope.row.name)"
                  @click="handleDeleteField(scope.$index, scope.row)"
                  class="btn add-filter-btn"
                >
                  <i class="ri-delete-bin-fill medium-icon"></i>
                </button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Loading
        :active="deletingDocument"
        :height="40"
        :width="40"
        :is-full-page="false"
        class="loader"
        loader="bars"
      />

      <div v-if="['users', 'doctors', 'admin'].includes(collection.id)" class="pb-3 pt-3 tabs-container">
    <el-tabs tab-position="left">
      <el-tab-pane label="Verify Email" class="pt-4">
        <el-form class="ml-3">
          <el-form-item>
            <el-button :loading="settingEmailAsVerified" class="btn action-btn apply-btn mr-2" @click="setEmailAsVerified"><span class="white-text">Set Email as Verified</span></el-button>
            <!-- <el-button class="btn action-btn" @click="sendVerificationEmail">Send Verification Email</el-button> -->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Reset password" class="pt-4">
        <el-form :model="resetPasswordForm" class="ml-3" :rules="passwordFormRules" ref="resetPasswordFormRef">
    <el-form-item label="New Password" class="horizontal-form-item" prop="newPassword" >
      <div class="input-with-button">
        <el-input
          :model-value="resetPasswordForm.newPassword"
          @update:model-value="value => resetPasswordForm.newPassword = value"
          class="password-input"
        />
        <el-button :loading="resettingPassword" class="btn action-btn apply-btn" @click="resetPassword">Reset Password</el-button>
        <el-button class="btn action-btn" :loading="sendingResetEmail"  @click="handleSendPasswordResetEmail">Send Password Reset Email</el-button>
      </div>
    </el-form-item>
  </el-form>
  </el-tab-pane>
    </el-tabs>
  </div>
  </div>
  <el-skeleton class="mt-5 ml-2 mr-2" v-else :rows="5" animated />

</template>

<script>
import { onMounted, ref, watchEffect } from 'vue'
import { format } from 'date-fns'
import { ElMessageBox, ElNotification } from 'element-plus'
import { updateDocument, deleteDocument } from '../../../services/useDocument'
import getDocument from '../../../services/getDocument'
import { deleteField, doc, getDoc } from 'firebase/firestore'
import ExpandObjectField from './ExpandObjectField.vue'
import ExpandArrayField from './ExpandArrayField.vue'
import AddToField from './AddToField.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import getAllDeviceTypes from '../../../composables/getAllDeviceTypes'
import updateDevice from '../../../composables/updateDevice'
import { httpsCallable } from 'firebase/functions'
import firebase from '../../../../firebase'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import { useRouter } from 'vue-router'

export default {
  components: { ExpandObjectField, AddToField, ExpandArrayField, VueDatePicker, Loading },
  name: 'DocumentDisplay',
  props: ['collectionId', 'docId'],
  setup (props, context) {
    const { handlelUpdate } = updateDocument(props.collectionId, props.docId)
    const { handleDelete } = deleteDocument(props.collectionId)
    const { document } = getDocument(props.collectionId, props.docId)
    const { allDeviceTypes, loadDeviceTypes } = getAllDeviceTypes()
    const booleanOptions = [true, false]
    const editPopoverVisible = ref([])
    const formattedDocumentData = ref([])
    const addFieldPopoverVisible = ref(false)
    const resetPasswordFormRef = ref(null)
    const resettingPassword = ref(false)
    const auth = getAuth()
    const currentImagePreviewIndex = ref(0)
    const sendingResetEmail = ref(false)
    const updateFirebaseUser = httpsCallable(firebase.functions, 'updateFirebaseUser')
    const settingEmailAsVerified = ref(false)
    const resetPasswordForm = ref({
      newPassword: ''
    })
    const newFieldObject = ref({
      name: '',
      editValue: '',
      editType: 'string',
      invalidValueInput: false
    })
    const allowAddFieldsNames = ref([])
    const collection = ref(null)
    const router = useRouter()

    const setupCollectionObject = (newCollection) => {
      const collectionDocRef = doc(firebase.db, 'AllCollections', newCollection)
      getDoc(collectionDocRef).then((snapshot) => {
        if (snapshot.exists()) {
          collection.value = { id: snapshot.id, ...snapshot.data() }
        }
      })
    }
    onMounted(() => {
      setupCollectionObject(props.collectionId)
      loadDeviceTypes()
    })

    const feedbackReportsNameToQuestionsMap = {
      appointmentBookingStraightforward: 'Was the appointment booking feature straightforward?',
      appointmentTimelyNotifications: 'Did you receive timely notifications from therapists?',
      appRespondedQuickly: 'Did the app respond quickly to your actions, or did you experience any lags?',
      bugsEncountered: 'Please list any bugs or issues you encountered while using the app.',
      connectedToBluetooth: 'Did you easily connect the app to Bluetooth devices?',
      easeOfNavigationRating: 'Could you easily navigate through the app on a scale of 1-10? (1 worst, 10 best)',
      userExperienceRating: 'On a scale of 1-10, how would you rate the app\'s overall user experience? (1 worst, 10 best)',
      uiFriendlinessRating: 'I found the UI (User Interface) intuitive and user-friendly? (1 Strongly disagree, 10 Strongly agree)',
      exerciseVideoClarityRating: 'Exercise videos were easy to follow and understand (1 Strongly disagree, 10 Strongly agree)',
      exerciseVideoGlitches: 'Did you experience any bugs or glitches while accessing the exercise videos?',
      personalizedWorkoutPlansRating: 'How would you rate creating personalized workout plans with therapist guidance? (1 worst, 10 best)',
      foundWorkoutPlansEasily: 'Were you able to easily find and select workout plans?',
      understoodTexavieCoins: 'Were you able to understand and utilize the Texavie coins feature?',
      texavieCoinsIncentivesRating: 'How would you rate the incentives offered via Texavie coins? (1 worst, 10 best)',
      fileUploadIssues: 'Did you face any issues while uploading files to or from the app?',
      likedFeatures: 'What features did you like the most?',
      suggestedImprovements: 'What improvements or additional features would you suggest?',

    }

    watchEffect(() => {
      if (document.value && collection.value) {
        editPopoverVisible.value = Object.keys(document.value).map(() => false)
        if (collection.value.fields) {
          allowAddFieldsNames.value = Object.keys(collection.value.fields).filter(
            key => {
              if (collection.value.allFieldsNonEditable) {
                return false
              }
              if (collection.value.nonEditableFields && collection.value.nonEditableFields.includes(key)) {
                return false
              }
              return !(key in document.value)
            })
        }

        // Sort the document data by key except for id
        const entries = Object.entries(document.value)
        const idEntry = entries.find(([key]) => key === 'id')
        const otherEntries = entries.filter(([key]) => key !== 'id')
        otherEntries.sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        const sortedEntries = idEntry ? [idEntry, ...otherEntries] : otherEntries

        formattedDocumentData.value = sortedEntries.map(([key, value], index) => {
          let displayValue = ''
          let valueType = typeof value
          if (valueType === 'object' && !Array.isArray(value)) {
            objectKeyValuePairs.value[key] = transformObjectToKeyValuePairs(value)
          }

          if (value && typeof value.toDate === 'function') {
            displayValue = formatFirestoreTimestamp(value)
            valueType = 'timestamp'
          } else if (Array.isArray(value)) {
            valueType = 'array'
            if (value.length > 0 && typeof value[0] === 'object') {
              displayValue = '[' + value.map(obj => JSON.stringify(obj, null, 2)).join(', ') + ']'
            } else {
              displayValue = value.join(', ')
            }
          } else if (valueType === 'object' && value !== null && !(value instanceof Date)) {
            displayValue = JSON.stringify(value, null, 2)
            valueType = 'object'
          } else {
            displayValue = value
          }

          if (props.collectionId === 'feedbackReports') {
            key = feedbackReportsNameToQuestionsMap[key] || key
          }

          return {
            index: index,
            name: key,
            type: valueType,
            value: displayValue,
            editValue: displayValue,
            editType: collection.value.fields !== undefined ? collection.value.fields[key] : typeof value,
            actualValue: value,
            invalidValueInput: false
          }
        })
      }
    })

    const formatFirestoreTimestamp = (timestamp) => {
      if (timestamp && timestamp.toDate) {
        return format(timestamp.toDate(), 'yyyy-MM-dd HH:mm:ss:sss')
      }
      return timestamp
    }

    const trucateString = (value) => {
      if (value === null || value === undefined) return ''
      return value.length > 40 ? value.substring(0, 40) + '...' : value
    }

    const goBack = () => {
      router.go(-1)
    }

    const tableRowClassName = (row) => {
      if (!isRowArrayOrObject(row.row) || (collection.value.nonExpandable && collection.value.nonExpandable.includes(row.row.name))) {
        return 'no-expand'
      }
    }

    const objectKeyValuePairs = ref({})
    const transformObjectToKeyValuePairs = (obj) => {
      if (obj == null) {
        return []
      }

      return Object.entries(obj)
        .map(([key, value]) => ({ key, value, id: key }))
        .sort((a, b) => a.key.localeCompare(b.key))
    }

    const isRowArrayOrObject = (row) => {
      return row.type === 'array' || row.type === 'object'
    }

    const handleDeleteField = (index, row) => {
      ElMessageBox.confirm(`This will delete the data at '${row.name}'' from the document`, 'Delete Data', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await deleteFieldFromDocument(row.name)
      }).catch((e) => {
        console.log(e)
      })
    }

    const deletingDocument = ref(false)
    const handleDeleteDocument = () => {
      // TODO: for users collection, remove any other references to this user?
      ElMessageBox.confirm('This will permanently delete all data at this location, including all nested data', 'Delete Data', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        deletingDocument.value = true
        await handleDelete(props.docId, true)
        context.emit('refetchDocumentsForCurrentCollection')
        goBack()
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        deletingDocument.value = false
      })
    }

    const deleteFieldFromDocument = async (field) => {
      await handlelUpdate({
        [field]: deleteField()
      })
    }

    const handleUpdateField = async (row) => {
      let newValue
      row.invalidValueInput = false
      switch (row.editType) {
        case 'number':
          newValue = parseFloat(row.editValue)
          if (isNaN(newValue)) {
            row.invalidValueInput = true
            return
          }
          break
        case 'boolean':
          newValue = row.editValue
          break
        case 'string':
        case 'selections':
          newValue = row.editValue
          break
        default:
          return
      }
      const data = {
        [row.name]: newValue
      }

      if (row.name === 'firstName' && ['users', 'doctors', 'admin'].includes(props.collectionId)) {
        data.lastName = document.value.lastName
      }
      if (row.name === 'lastName' && ['users', 'doctors', 'admin'].includes(props.collectionId)) {
        data.firstName = document.value.firstName
      }

      try {
        await handlelUpdate(data, true)
        row.invalidValueInput = false
        // resetRowValues(row)
      } catch (error) {
        console.log(error)
      }
    }

    const toggleEditFieldPopover = (index) => {
      if (index >= 0 && index < editPopoverVisible.value.length) {
        editPopoverVisible.value[index] = !editPopoverVisible.value[index]
      }
    }

    const resetRowValues = (row) => {
      row.editValue = row.value
      row.editType = row.type
      row.invalidValueInput = false
    }

    const onCancelPopover = (row) => {
      toggleEditFieldPopover(row.index)
      resetRowValues(row)
    }

    const onCancelNewFieldPopover = () => {
      addFieldPopoverVisible.value = false
      newFieldObject.value = {
        name: '',
        type: 'string',
        value: '',
        editValue: '',
        editType: 'string',
        invalidValueInput: false
      }
    }

    const onNewFiledOjectNameSelected = () => {
      newFieldObject.value.editType = collection.value.fields[newFieldObject.value.name]
      newFieldObject.value.actualType = newFieldObject.value.editType === 'selections' ? 'string' : newFieldObject.value.editType
      if (newFieldObject.value.editType === 'array') {
        const schema = collection.value.schema[newFieldObject.value.name]
        const itemType = schema.itemType
        let newItemInArray
        if (itemType === 'object') {
          // Object type in array
          // user sessions/web3wallets transactions
          newItemInArray = {
            editValue: [],
            fieldEnabled: false,
            objectKeysLength: Object.keys(schema.object).length
          }

          for (const [key, value] of Object.entries(schema.object)) {
            newItemInArray.editValue.push({
              field: key,
              value: '',
              editType: value,
              invalidValueInput: false,
              actualType: value === 'selections' ? 'string' : value,
              selections: props.schema.selections ? props.schema.selections[key] : []
            })
          }
        } else {
          // Primitive type in array
          newItemInArray = {
            editValue: null,
            editType: itemType,
            invalidValueInput: false,
            actualType: itemType === 'selections' ? 'string' : itemType,
            fieldOmitted: true
          }
        }
        newFieldObject.value.numItemsInArray = 1
        newFieldObject.value.editValue = [newItemInArray]
      } else if (newFieldObject.value.editType === 'object') {
        const schema = collection.value.schema[newFieldObject.value.name]
        let newItemInArray

        if (!schema.object) {
          // Fixed key and value
          newItemInArray = {
            editField: '',
            editValue: '',
            invalidValueInput: false,
            invalidFieldInput: false,
            fieldEnabled: true,
            selections: schema.selections,
            editType: schema.value,
            actualType: schema.value === 'selections' ? 'string' : schema.value
          }
          if (newFieldObject.value.name === 'devices') {
            newItemInArray.deviceType = ''
            newItemInArray.invalidDeviceType = false
          }
        } else {
          // dont have this case yet
        }
        newFieldObject.value.numItemsInArray = 1
        newFieldObject.value.editValue = [newItemInArray]
      } else {
        newFieldObject.value.editValue = ''
        newFieldObject.value.invalidValueInput = false
      }
    }

    const handleAddField = async () => {
      newFieldObject.value.invalidValueInput = false

      if (newFieldObject.value.editType === 'array') {
        // newFieldObject.value.editValue = newFieldObject.value.editValue.map(item => {
        //   if (item.fieldOmitted) {
        //     return item.editValue
        //   } else {
        //     const newItem = {}
        //     for (const [key, value] of Object.entries(item)) {
        //       if (key !== 'field' && key !== 'invalidValueInput' && key !== 'actualType' && key !== 'selections') {
        //         newItem[key] = value
        //       }
        //     }
        //     return newItem
        //   }
        // })
      } else if (newFieldObject.value.editType === 'object') {
        const newValue = {}
        for (const item of newFieldObject.value.editValue) {
          if (!validateInputValue(item)) {
            return
          }
          newValue[item.editField] = item.editValue
          if (newFieldObject.value.name === 'devices' && props.collectionId === 'users') {
            newValue.deviceType = item.deviceType
            newValue.deviceId = item.editField
          }
        }
        await addNewFieldToDoc(newFieldObject.value.name, newValue)
      } else {
        // primitive types
        if (!validateInputValue(newFieldObject.value)) {
          return
        }
        const newValue = newFieldObject.value.editValue
        await addNewFieldToDoc(newFieldObject.value.name, newValue)
      }
    }

    const addNewFieldToDoc = async (field, newValue) => {
      try {
        if (field === 'devices' && props.collectionId === 'users') {
          const { updateDeviceBasedOnId } = updateDevice()
          await updateDeviceBasedOnId(newValue.deviceId, newValue.deviceType, props.docId)
          delete newValue.deviceType
          delete newValue.deviceId
        }
        await handlelUpdate({
          [newFieldObject.value.name]: newValue
        })

        onCancelNewFieldPopover()
      } catch (error) {
        console.log(error)
      }
    }

    const validateInputValue = (item) => {
      let newValue
      item.invalidValueInput = false
      if ('invalidDeviceType' in item) {
        item.invalidDeviceType = false
        if (item.deviceType === '') {
          item.invalidDeviceType = true
          return false
        }
      }

      if (item.fieldEnabled) {
        item.invalidFieldInput = false
        if (item.editField === '') {
          item.invalidFieldInput = true
          return false
        }
      }

      switch (item.editType) {
        case 'number':
          newValue = parseFloat(item.editValue)
          if (isNaN(newValue)) {
            item.invalidValueInput = true
            return false
          }
          item.editValue = newValue
          return true
        case 'boolean':
          return true
        case 'string':
          return item.editValue !== ''
        case 'timestamp':
          newValue = new Date(item.editValue)
          if (isNaN(newValue)) {
            item.invalidValueInput = true
            return false
          }
          item.editValue = newValue
          return true
        case 'selections':
          if (!item.selections.includes(item.editValue)) {
            item.invalidValueInput = true
            return false
          }
          return true
        default:
      }
    }

    const addItemToNewValue = () => {
      if (newFieldObject.value.editType === 'array') {
      } else if (newFieldObject.value.editType === 'object') {
        const schema = collection.value.schema[newFieldObject.value.name]
        let newItemInArray

        if (!schema.object) {
          // Fixed key and value
          newItemInArray = {
            editField: '',
            editValue: '',
            invalidValueInput: false,
            invalidFieldInput: false,
            fieldEnabled: true,
            actualType: schema.value === 'selections' ? 'string' : schema.value,
            selections: schema.selections,
            editType: schema.value
          }
        }
        if (newFieldObject.value.name === 'devices') {
          newItemInArray.deviceType = ''
          newItemInArray.invalidDeviceType = false
        }
        newFieldObject.value.numItemsInArray += 1
        newFieldObject.value.editValue.push(newItemInArray)
      }
    }

    const removeItemFromNewValue = (index) => {
      if (newFieldObject.value.editType === 'array') {
      } else if (newFieldObject.value.editType === 'object') {
        newFieldObject.value.numItemsInArray -= 1
        newFieldObject.value.editValue.splice(index, 1)
      }
    }

    const setEmailAsVerified = async () => {
      settingEmailAsVerified.value = true
      await updateFirebaseUser({
        uid: props.docId,
        emailVerified: true
      })
      ElNotification({
        title: 'Success',
        message: 'Email has been verified',
        type: 'success'
      })
      settingEmailAsVerified.value = false
    }

    const sendVerificationEmail = async () => {
    }

    const handleSendPasswordResetEmail = async () => {
      sendingResetEmail.value = true

      try {
        await sendPasswordResetEmail(auth, document.value.email)
        ElNotification({
          title: 'Success',
          message: 'Reset email has been sent',
          type: 'success'
        })
      } catch (error) {
        console.error('Error sending password reset email:', error)
      } finally {
        sendingResetEmail.value = false
      }
    }

    const passwordFormRules = ref({
      newPassword: [
        {
          validator: (rule, value, callback) => {
            if (value.length < 8) {
              return callback(new Error('Password must be at least 8 characters long'))
            }
            if (!/[A-Za-z]/.test(value)) {
              return callback(new Error('Password must contain at least one letter'))
            }
            if (!/\d/.test(value)) {
              return callback(new Error('Password must contain at least one number'))
            }
            if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
              return callback(new Error('Password must contain at least one special character'))
            }
            callback()
          },
          trigger: 'blur'
        }
      ]
    })
    const resetPassword = async () => {
      resetPasswordFormRef.value.validate(async (valid) => {
        if (valid) {
          resettingPassword.value = true
          await updateFirebaseUser({
            uid: props.docId,
            password: resetPasswordForm.value.newPassword
          })
          ElNotification({
            title: 'Success',
            message: 'Password has been reset',
            type: 'success',
          })
          resettingPassword.value = false
          resetPasswordForm.value.newPassword = ''
        }
      })
    }

    return {
      formattedDocumentData,
      goBack,
      trucateString,
      tableRowClassName,
      isRowArrayOrObject,
      handleDeleteField,
      handleUpdateField,
      document,
      editPopoverVisible,
      toggleEditFieldPopover,
      booleanOptions,
      onCancelPopover,
      addFieldPopoverVisible,
      newFieldObject,
      onCancelNewFieldPopover,
      handleAddField,
      handleDeleteDocument,
      allowAddFieldsNames,
      onNewFiledOjectNameSelected,
      transformObjectToKeyValuePairs,
      objectKeyValuePairs,
      addItemToNewValue,
      removeItemFromNewValue,
      deletingDocument,
      allDeviceTypes,
      resetPasswordForm,
      setEmailAsVerified,
      settingEmailAsVerified,
      resetPasswordFormRef,
      resetPassword,
      passwordFormRules,
      resettingPassword,
      handleSendPasswordResetEmail,
      sendingResetEmail,
      sendVerificationEmail,
      collection,
      currentImagePreviewIndex
    }
  }
}
</script>

<style scoped>
.back-button {
  border-radius: 10px;
  border: 1px solid var(--border-color);
  color: var(--muted-text-color);
  background-color: var(--light-grey);
  padding: 0px 5px;
  font-size: 14px;
}
.align {
  display: flex;
  align-items: baseline;
}

.field-name {
  font-weight: bold;
  margin-top: 15px;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-color);
  padding: 5px 20px;
  background-color: #f4f5f7;
}

.document-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 13px !important;
}

.header-section {
  display: flex;
  align-items: center;
}

.medium-icon {
  font-size: 16px;
  color: #a09e9e;
}

.document-title {
  color: #3f414d;
}

.filter-row span {
  white-space: nowrap;
  margin-right: 8px;
}

.filter {
  flex: 1;
  margin-right: 8px;
}

.filter-select {
  min-width: 190px;
}

.filter-content {
  margin: 10px 10px 20px 10px;
  display: flex;
  flex-direction: column;
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border-color);
  padding-top: 15px;
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
}

.filter-label-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  position: relative;
}

.filter-label-input label {
  margin-bottom: 10px;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.action-buttons {
  display: flex;
}

.filter-label-input label {
  margin-bottom: 0.5rem;
}

.filter {
  width: 100%;
}

.invalid-input-message {
  color: #ff4d4f;
  font-size: 11px;
  position: absolute;
  bottom: -20px;
  left: 0;
  visibility: hidden;
}

.filter-label-input .is-invalid + .invalid-input-message {
  visibility: visible;
}

.action-btn {
  background-color: #e1e5e8;
  color: black;
  font-size: 13px !important;
}

.apply-btn {
  background-color: green;
  color: white;
}

.apply-btn:hover {
  color: white;
  background-color: darkgreen;
}

.keyValueEditors {
  display: block;
  padding-left: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.vertical-dots {
  position: absolute;
  top: -13px;
  bottom: 10px;
  left: 30px;
  background-image: linear-gradient(
    to bottom,
    var(--dots-color) 50%,
    transparent 0%
  );
  background-repeat: repeat-y;
  background-size: 2px 6px;
  width: 2px;
}

.object-field-container {
  position: relative;
  padding-left: 40px;
}

.object-field-container .add-item {
  font-size: 20px !important;
  margin-top: 3px;
  color: var(--dots-color);
  cursor: pointer;
}

.remove-item {
  margin-top: 11px;
  font-size: 20px !important;
  color: var(--dots-color);
  cursor: pointer;
}

.keyValueEditors .filter-row {
  position: relative;
}

.keyValueEditors .filter-row::before {
  content: "";
  position: absolute;
  top: 60%;
  left: -20px;
  width: 20px;
  height: 2px;
  background-image: linear-gradient(
    to right,
    var(--dots-color) 50%,
    transparent 50%
  );
  background-size: 10px 2px;
  background-repeat: repeat-x;
}

.add-field-plus {
  display: flex;
  flex-direction: row;
}

.plus-dots {
  background-image: linear-gradient(
    to right,
    var(--dots-color) 50%,
    transparent 50%
  );
  background-position: bottom;
  background-repeat: repeat-x;
  background-size: 10px 2px;
  margin-left: -10px;
  height: 22px;
  width: 20px;
  margin-right: 3px;
}

.horizontal-form-item {
  display: flex;
  align-items: center;
}

.input-with-button {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.password-input {
  flex-grow: 1;
  margin-right: 10px;
  width: 320px;
}

.action-buttons {
  display: block;
}

.tabs-container {
  border-bottom: 1px solid #e0e0e0;
}


.image-wall {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    margin-top: 10px;
    gap: 8px;
  }

  .image-item {
    width: 100%;
    object-fit: cover;
    cursor: pointer;
    overflow: hidden;
    border: 1px dotted var(--border-color);
    border-radius: 6px;
    box-sizing: border-box;
    width: 120px;
    height: 120px;
    display: inline-flex;
  }

</style>

<style>
.no-expand .el-icon {
  display: none;
}
.no-expand .el-table__expand-icon {
  pointer-events: none;
}

.el-popover {
  transition: none !important;
}

.el-fade-in-linear-enter-active,
.el-fade-in-linear-leave-active {
  transition: opacity 0s !important;
}

.el-fade-in-linear-enter,
.el-fade-in-linear-leave-to {
  opacity: 1 !important;
}

.el-notification__title {
  font-size: 16px !important;
}

</style>
